import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { ScrollService } from '../../../_services/scroll.service';
interface IFormData {
  full_name: string;
  email: string;
  company: string;
  message: string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public bookDemoForm: UntypedFormGroup = null;
  public submitBtn: HTMLButtonElement;

  @ViewChild(FormGroupDirective, { static: false }) bookDemo: FormGroupDirective;

  constructor(
    public formBuilder: UntypedFormBuilder,
    public router: Router,
    private scrollService: ScrollService
  ) {
    this.bookDemoForm = this.formBuilder.group({
      full_name: ['', [Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      company: ['', [Validators.required]],
      message: ['', [Validators.required, Validators.minLength(20)]]
    });
  }

  ngOnInit(): void {}

  get formData() {
    return this.bookDemoForm.controls as Record<string, AbstractControl<IFormData>>;
  }

  bookedDemo() {
    let formData: IFormData | null;
    try {
      if (this.bookDemoForm.invalid) {
        return false;
      } else {
        formData = {
          full_name: this.bookDemoForm.get<keyof IFormData>('full_name').value,
          email: this.bookDemoForm.get<keyof IFormData>('email').value,
          company: this.bookDemoForm.get<keyof IFormData>('company').value,
          message: this.bookDemoForm.get<keyof IFormData>('message').value
        };

        this.bookDemoForm.reset();
        const btn = document.getElementById('bookDemoSubmit') as HTMLButtonElement;

        btn?.setAttribute('data-bs-dismiss', 'modal');

        setTimeout(() => {
          btn.click();
        }, 100);

        // this.galleryService.setGallery(formData).subscribe(
        //   (res) => {
        //     this.sharedService.setGallerySubmission = res['success'];
        //   },
        //   (error) => {}
        // );
      }
    } catch (error) {
      error instanceof Error && console.log(error.message);
    }
  }

  scrollToId(id: string) {
    this.router.navigate(['/']);
    setTimeout(() => this.scrollService.scrollToElementById(id), 100);
  }
}
